import Wahanda from 'common/wahanda';

const lang = Wahanda.lang.settings.employees.employee.errors;

const employeeErrors = {
  delete: {
    'employee-in-use': lang.deletingEmployeeInUse,
  },
  name: {
    'employee-name-in-use': lang.duplicateName,
  },
  email: {
    'employee-email-address-in-use': lang.emailInUse,
  },
  takesAppointments: {
    'employee-in-use': lang.deactivatingEmployeeInUse,
  },
  submit: {
    'insufficient-privilege-to-manage-employee': lang.insufficientPrivilegeToManageEmployee,
    'venue-permission-denied': lang.venuePermissionDenied,
  },
};

export default employeeErrors;
